import axios from "axios";

import mask from "@/utils/masks";
import cookie from "@/utils/cookie";

export default class service {
  get token() {
    return cookie.get("token");
  }

  saveToken(value) {
    cookie.set("token", value);
  }

  removeToken() {
    cookie.remove("token");
  }

  pendingRequestCount = 0;

  get isBusy() {
    return this.pendingRequestCount > 0;
  }

  async http(config, busy = true, onSuccess = null, onError = null) {
    if (busy) {
      this.pendingRequestCount++;
    }

    config.validateStatus = (status) => {
      return status < 600;
    };

    if (this.token) {
      config.headers = { Authorization: `Bearer ${this.token}` };
    }

    // set timeout
    config.timeout = 100000;
    setTimeout(() => {
      if (busy) {
        this.pendingRequestCount--;
      }

      if (onError) {
        onError({
          type: "Timeout",
          message:
            "İşlem zaman aşımına uğradı. Lütfen daha sonra tekrar deneyiniz.",
        });
      }
    }, config.timeout);

    // start request
    let response = null;
    try {
      response = await axios(config);
    } catch (error) {
      console.error(error);

      if (onError) {
        onError({
          type: "Error",
          message: error,
        });
      }
    }

    // handle response
    if (response) {
      response.hasStatusError = 300 <= response?.status;

      if (response?.status === 401) {
        this.removeToken();

        if (onError) {
          onError({
            type: "Unauthorized",
            message: "Yetkisiz erişim.",
          });
        }
      }
    }

    if (busy) {
      this.pendingRequestCount--;
    }

    if (onSuccess) {
      onSuccess(response);
    }

    return response;
  }

  async GetCaptcha({ busy = true, onSuccess = null, onError = null }) {
    let response = await this.http(
      {
        method: "post",
        url: process.env.VUE_APP_API_BASE_URL + "GenelOrtak/GetCaptcha",
        data: {
          ApplicationCode: process.env.VUE_APP_CAPTCHA_CODE,
        },
      },
      busy
    );

    if (
      response?.data?.Data?.RefCode &&
      response?.data?.Data?.CaptchaImage
    ) {
      if (onSuccess) {
        onSuccess({
          code: response?.data?.Data?.RefCode,
          imageSrc: response?.data?.Data?.CaptchaImage
            ? "data:image/jpg;base64," + response?.data?.Data.CaptchaImage
            : null,
        });
      }
    } else {
      if (onError) {
        onError(
          response?.data?.Mesajlar[0].Mesaj ||
            "Üzgünüz, beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin."
        );
      }
    }
  }

  async GetWebAcenteAccessList() {
    //this.state.acente.varsayilanAcente = null

    let acenteGuid = (new URLSearchParams(window.location.search)).get('urlid')
    if (!acenteGuid) {
        return
    }

    let response = await this.http({
        method: 'post',
        url: process.env.VUE_APP_API_BASE_URL + 'GenelOrtak/GetWebAcenteAccessList',
        data: {
            SirketKod: 1,
            AcenteGuid: acenteGuid
        }
    })

    let acenteler = response?.data?.Items ?? []
    if (acenteler.length > 0) {
        return {
            Sube_Kod: acenteler[0].sube_kod,
            Kaynak_Kod: acenteler[0].kaynak_kod,
            Ad: acenteler[0].acente_adi,
            Acente_No: acenteler[0].acenta_no
        };
    }
}

  async CheckCaptcha({
    code = null,
    input = null,
    onSuccess = null,
    onError = null,
  }) {
    let response = await this.http(
      {
        method: "post",
        url: process.env.VUE_APP_API_BASE_URL + "GenelOrtak/CheckCaptcha",
        data: {
          ApplicationCode: process.env.VUE_APP_CAPTCHA_CODE,
          RefCode: code,
          CaptchaCode: input,
        },
      },
      false
    );

    if (response?.data?.HasAnyError) {
      if (onError) {
        onError({
          message: "Geçersiz bir güvenlik metni girdin.",
        });
      }
    } else {
      if (onSuccess) {
        onSuccess({});
      }
    }

    return response;
  }

  async GetToken({
    code = null,
    input = null,
    onSuccess = null,
    onError = null,
  }) {
    let response = await this.http({
      method: "post",
      url:
        process.env.VUE_APP_API_BASE_URL +
        "GenelOrtak/KotasyonLoginAccessToken",
      data: {
        ClientId: process.env.VUE_APP_API_CLIENT_ID,
        ClientSecret: process.env.VUE_APP_API_CLIENT_SECRET,
        CaptchaSession_Id: code,
        Captcha: input,
      },
    });

    if (response?.data?.access_token) {
      this.saveToken(response?.data.access_token);

      if (onSuccess) {
        onSuccess({
          access_token: response?.data.access_token,
        });
      }
    } else {
      if (onError) {
        onError({
          message:
            "Üzgünüz, beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
        });
      }
    }
  }

  async CheckUserCampaignPermission({
    Tckn = null,
    onSuccess = null,
    onError = null
  }){
    let response = await this.http({
      method: 'post',
      url: process.env.VUE_APP_API_BASE_URL + "KotasyonElementer/CheckUserCampaignPermission",
      data: {
        TCKN: Tckn
      }
    })
    let error = response.data.Data.Mesajlar;

    if (error) {
      if (onError) {
        onError(error);
      }
    }

    if (!error) {
      if (onSuccess) {
        onSuccess(response);
      }
    }
  }

  async InsertUserCampaignPermission({
    Tckn = null
  }){
    let response = await this.http({
      method: 'post',
      url: process.env.VUE_APP_API_BASE_URL + "KotasyonElementer/InsertUserCampaignPermission",
      data: {
        TCKN: Tckn,
        IsAllowed: 1,
        OpId: 'DijitalSaglik',
        ReferencePage: 'DijitalSaglik'
      }
    })
    return response;
  }

  async InsertUpdateLead({
    sigortali = null,
    onSuccess = null,
    onError = null,
    onCompleted = null,
    acenteNo = null
  }) {
    /* let ipResponse = await this.http({
            method: 'get',
            url: 'https://api.ipify.org/?format=json',
        }); */

    let response = await this.http({
      method: "post",
      url:
        process.env.VUE_APP_API_BASE_URL + "KotasyonElementer/InsertUpdateLead",
      data: {
        // RequestIP: ipResponse?.ip ?? '10.60.72.152',
        Tckn: sigortali.kimlikNo,
        Email: sigortali.ePosta,
        DogumTarihi: mask.unMaskDogumTarihi(sigortali.dogumTarihi),
        CepTelNo: mask.unMaskCepNo(sigortali.cepNo),
        TarifeKod: "DSS",
        GizlilikSozlesmeOnay: sigortali.gizlilikSozlesmeOnay,
        AcenteNo : acenteNo
        // ElektronikIletiOnay: sigortali.elektronikIletiOnay,
        // tanzim_tarihi: moment().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' //2021-11-11T11:56:00.262Z
      },
    });

    // Error handling
    let error = null;

    // No data error
    if (!response) {
      error = {
        type: "Unknown",
        message: null,
      };
    }

    // Custom error
    if (response?.data?.Data === false) {
      error = {
        type: response?.data?.Mesajlar[0]?.Tip || response?.Type || "Unknown",
        message:
          response.data.Mesajlar[0]?.Kod === "000"
            ? "Lütfen doğum tarihinizi doğru girdiğinizden emin olun."
            : response?.data?.Mesajlar[0]?.Mesaj ||
              response?.Message ||
              "Üzgünüz, beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
      };
    }

    // Call onCompleted
    if (onCompleted) {
      onCompleted(response || error || null);
    }

    // Call onError
    if (error) {
      if (onError) {
        onError(error);
      }
    }

    // Call onSuccess
    if (!error) {
      if (onSuccess) {
        onSuccess(response);
      }
    }
  }

  async SmsKoduDogrula({
    sigortali = null,
    onSuccess = null,
    onError = null,
    onCompleted = null,
  }) {
    let response = await this.http({
      method: "post",
      url:
        process.env.VUE_APP_API_BASE_URL + "KotasyonElementer/SmsKoduDogrula",
      data: {
        CepNo: mask.unMaskCepNo(sigortali.cepNo),
        PoliceGuid: "",
        DogrulamaKodu: sigortali.smsDogrulamaKodu || "",
        TarifeKod: "DSS",
        KimlikNo: sigortali.kimlikNo,
      },
    });

    // Error handling
    let error = null;

    // No data error
    if (!response) {
      error = {
        type: "Unknown",
        message: null,
      };
    }

    /**
     * @valid
     */
    // Custom error
    if (response?.data?.Data === false) {
      error = {
        type: response?.data?.Mesajlar[0]?.Tip || response?.Type || "Unknown",
        message:
          response?.data?.Mesajlar[0]?.Mesaj ||
          response?.Message ||
          "Üzgünüz, beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
      };
    }

    // Call onCompleted
    if (onCompleted) {
      onCompleted(response || error || null);
    }

    // Call onError
    if (error) {
      if (onError) {
        onError(error);
      }
    }

    // Call onSuccess
    if (!error) {
      if (onSuccess) {
        onSuccess(response);
      }
    }
  }

  async OnaySmsGonder({
    sigortali = null,
    onSuccess = null,
    onError = null,
    onCompleted = null,
  }) {
    let response = await this.http({
      method: "post",
      url: process.env.VUE_APP_API_BASE_URL + "KotasyonElementer/OnaySmsGonder",
      data: {
        CepNo: mask.unMaskCepNo(sigortali.cepNo),
        PoliceGuid: "",
        DogrulamaKodu: "",
        TarifeKod: "DSS",
        KimlikNo: sigortali.kimlikNo,
      },
    });

    // Error handling
    let error = null;

    // No data error
    if (!response) {
      error = {
        type: "Unknown",
        message: null,
      };
    }

    // Custom error
    if (response?.data?.Data === false) {
      error = {
        type: response?.data?.Mesajlar[0]?.Tip || response?.Type || "Unknown",
        message:
          response?.data?.Mesajlar[0]?.Mesaj ||
          response?.Message ||
          "Üzgünüz, beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
      };
    }

    // Call onCompleted
    if (onCompleted) {
      onCompleted(response || error || null);
    }

    // Call onError
    if (error) {
      if (onError) {
        onError(error);
      }
    }

    // Call onSuccess
    if (!error) {
      if (onSuccess) {
        onSuccess(response);
      }
    }
  }
}
